import { MutationHookOptions, useMutation } from '@apollo/client';

import { DELETE_PROGRAM_ONBOARDING_TEMPLATE } from '@frontend/app/queries/DeleteProgramOnboardingTemplateMutation';
import {
  DeleteProgramOnboardingTemplateMutation,
  DeleteProgramOnboardingTemplateMutationVariables,
} from '@frontend/app/queries/types/DeleteProgramOnboardingTemplateMutation';

type IOptions = MutationHookOptions<
  DeleteProgramOnboardingTemplateMutation,
  DeleteProgramOnboardingTemplateMutationVariables
>;

export const useDeleteProgramOnboardingTemplate = (options: IOptions = {}) =>
  useMutation(DELETE_PROGRAM_ONBOARDING_TEMPLATE, options);
